import { HttpError } from 'react-admin';
import { getSubmissionErrors } from 'utils/getSubmissionErrors';

const FIELDS_GENERATED_FROM_ALIAS = ['name', 'externalAlias', 'method.name', 'method.alias'];

export const getGatewayBulkSubmissionErrors = (error: HttpError) =>
  Object.fromEntries(
    Object.entries(getSubmissionErrors(error)).map(([propertyPath, message]) => [
      FIELDS_GENERATED_FROM_ALIAS.includes(propertyPath) ? 'alias' : propertyPath,
      message,
    ]),
  );
